import type { ReactElement } from "react";

/** Loading skeleton для catalog grid (12 cards). */
export function CatalogSkeleton({ count = 6 }: { count?: number }): ReactElement {
  return (
    <div className="catalog__grid" aria-hidden>
      {Array.from({ length: count }).map((_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  );
}

function ProductCardSkeleton(): ReactElement {
  return (
    <div className="product-card product-card--skeleton">
      <div className="product-card__image skeleton-shimmer" />
      <div className="product-card__body">
        <div className="skeleton-line skeleton-line--lg skeleton-shimmer" />
        <div className="skeleton-line skeleton-shimmer" />
        <div className="skeleton-line skeleton-shimmer" />
        <div className="skeleton-line skeleton-line--sm skeleton-shimmer" />
        <div className="skeleton-line skeleton-line--btn skeleton-shimmer" />
      </div>
    </div>
  );
}
